import axiosInstance, { endpoints } from 'src/utils/axios';

export async function getAllFormations(userID, formationId) {
  
    // console.log(userID)
  // console.log( `Envoi d'une requête pour récupérer les formations de l'utilisateur avec ID ${userID} et la formation ${formationId}` );
  try {
    const response = await axiosInstance.get(
      `${endpoints.formations.getAll}/${userID}/trainees/${formationId}`
    );
    // console.log('Réponse de la requête  depuis le services:', response.data);
    return response.data;
  } catch (error) {
    // console.error('Erreur lors de la requête :', error);
    return error;
  }
}
